module.exports = __webpack_public_path__ + "img/shope.a4512e80.png";